import {
  consignmentAndReturnFactory,
  resumeFactory,
  returnRequestListFactory,
} from 'factories';
import { requestAxios } from 'services';
import {
  ConsignmentAndReturnParams,
  ConsignmentAndReturnResponse,
  Resume,
  ReturnRequestListParams,
  ReturnRequestListResponse,
} from 'types';

async function getResume(): Promise<Resume> {
  let result: any = {};

  try {
    const response = await requestAxios.get(
      'consignment-and-return/return-request/resume'
    );

    result = response.data;
  } catch (error) {
    console.error(error);
  }

  return resumeFactory(result);
}

async function getReturnRequests(
  params: ReturnRequestListParams
): Promise<ReturnRequestListResponse> {
  let result: any = {};

  try {
    const response = await requestAxios.get(
      'consignment-and-return/return-request',
      { params }
    );

    result = response.data;
  } catch (error) {
    console.error(error);
  }

  return returnRequestListFactory(result);
}

async function getConsignmentAndReturn(
  params: ConsignmentAndReturnParams = {}
): Promise<ConsignmentAndReturnResponse> {
  let result: any = {};

  try {
    const response = await requestAxios.get('consignment-and-return', {
      params,
    });

    result = response.data;
  } catch (error) {
    console.error(error);
  }

  return consignmentAndReturnFactory(result);
}

async function postRefund({
  protocol,
  password,
}: {
  protocol: string;
  password: string;
}): Promise<any> {
  let result: any = {};

  try {
    const response = await requestAxios.post(
      `consignment-and-return/return-request/${protocol}/refund`,
      { password }
    );

    result = response.data;
  } catch (error) {
    console.error(error);
  }

  return result;
}

async function postConsignmentRefund({
  code,
  type,
  password,
  entries,
  deliveryCostRefundAmount,
}: {
  code: string;
  type: string;
  password: string;
  entries?: number[];
  deliveryCostRefundAmount?: number;
}): Promise<any> {
  let result: any = {};

  try {
    const response = await requestAxios.post(
      `consignment-and-return/consignment/${code}/refund`,
      {
        type,
        entries,
        deliveryCostRefundAmount,
        password,
      }
    );

    result = response.data;
  } catch (error) {
    console.error(error);
  }

  return result;
}

export const returnRequestService = {
  getResume,
  getReturnRequests,
  getConsignmentAndReturn,
  postRefund,
  postConsignmentRefund,
};
